<template>
  <DynamicModal
    :showModal="showModalProp"
    :persistent="false"
    @clickOutside="closeModal"
    title="Geolocation Details"
    maxWidth="800px"
  >
    <v-container fluid slot="title-buttons" class="py-1">
      <v-row justify="end">
        <v-btn
          icon
          depressed
          color="primary"
          @click="closeModal"
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-container fluid slot="content">
      <div class="mt-3">
        <v-row>
          <v-col cols="12">
            <div class="mapouter">
              <div class="gmap_canvas">
                <iframe
                  width="100%"
                  height="350"
                  id="gmap_canvas"
                  :src="source"
                  frameborder="0"
                  scrolling="no"
                  marginheight="0"
                  marginwidth="0">
                </iframe>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <b>Latitude:</b> {{ latitude }}
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <b>Longitude:</b> {{ longitude }}
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <b>IP Address:</b> {{ ipAddress }}
          </v-col>
        </v-row>
      </div>
    </v-container>
    <v-container fluid slot="buttons" class="pb-0 mb-0">
      <div class="row d-flex justify-end">
        <div class="col-12">
          <v-btn
            block
            depressed
            outlined
            @click="closeModal"
          >
            Back
          </v-btn>
        </div>
      </div>
    </v-container>
  </DynamicModal>
</template>
<script>
import { DynamicModal } from '@/components/dialogs'

export default {
  components: {
    DynamicModal
  },
  data () {
    return {
      showModalProp: false,
      latitude: null,
      longitude: null,
      ipAddress: null
    }
  },
  computed: {
    source () {
      return `https://maps.google.com/maps?q=${this.latitude},${this.longitude}&t=&z=17&ie=UTF8&iwloc=&output=embed`
    }
  },
  methods: {
    showModal (latitude, longitude, ipAddress) {
      this.latitude = latitude
      this.longitude = longitude
      this.ipAddress = ipAddress
      this.showModalProp = true
    },
    closeModal () {
      this.latitude = null
      this.longitude = null
      this.ipAddress = null
      this.showModalProp = false
      this.$emit('closeGeolocationDetails')
    }
  }
}
</script>

<style>
.mapouter{
  height: 350px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.gmap_canvas {
  overflow: hidden;
  background: none!important;
  height: 350px;
  width: 100%;
}
</style>
